import { render } from "./modal-ticket-review.vue?vue&type=template&id=cc299870&ts=true"
import script from "./modal-ticket-review.vue?vue&type=script&lang=ts"
export * from "./modal-ticket-review.vue?vue&type=script&lang=ts"

import "./modal-ticket-review.vue?vue&type=style&index=0&id=cc299870&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__